import * as React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import tw from "twin.macro"
import styled from "@emotion/styled"
import Img from "gatsby-image"

const links = [
  {
    label: "Home",
    url: "/",
  },
  {
    label: "About",
    url: "/about/",
  },
  {
    label: "Calendar",
    url: "/calendar/",
  },
  {
    label: "Competitions",
    url: "/competitions/",
  },
  {
    label: "Projects",
    url: "/projects/",
  },
]

const DesktopLink = styled(Link)`
  ${tw`ml-8 inline-flex items-center py-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out`}

  &.active {
    ${tw`border-blue-500 text-blue-700 focus:border-blue-700`}
  }
`

const MobileLink = styled(Link)`
  ${tw`block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out sm:pl-5 sm:pr-6`}

  &.active {
    ${tw`border-blue-500 text-blue-700 bg-blue-50 focus:text-blue-800 focus:bg-blue-100 focus:border-blue-700`}
  }
`

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "logo.jpg" }) {
        childImageSharp {
          fixed(height: 80, width: 196, quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <nav tw="relative bg-white shadow z-20">
      <div tw="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div tw="flex justify-between h-20">
          <div tw="flex">
            <div tw="-ml-2 mr-2 flex items-center md:hidden">
              {/* Mobile menu button */}
              <button
                tw="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
                aria-label="Main menu"
                aria-expanded="false"
                onClick={() => setIsOpen(!isOpen)}
              >
                {!isOpen ? (
                  <svg
                    tw="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                ) : (
                  <svg
                    tw="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            </div>
            <Link to="/" tw="flex-shrink-0 flex items-center">
              <Img
                tw="block h-20 w-auto"
                fixed={data.file.childImageSharp.fixed}
                alt="FBLA Logo"
              />
            </Link>
            <div tw="hidden md:ml-6 md:flex items-center">
              {links.map((link, idx) => (
                <DesktopLink
                  to={link.url}
                  key={link.url}
                  activeClassName="active"
                >
                  {link.label}
                </DesktopLink>
              ))}
            </div>
          </div>
          <div tw="flex items-center">
            <div tw="flex-shrink-0">
              <Link
                to="/join"
                tw="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 shadow-sm hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150"
              >
                <span>Join Us</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {isOpen ? (
        <div tw="md:hidden">
          <div tw="pt-2 pb-3 space-y-1">
            {links.map((link, idx) => (
              <MobileLink to={link.url} key={link.url} activeClassName="active">
                {link.label}
              </MobileLink>
            ))}
          </div>
        </div>
      ) : null}
    </nav>
  )
}
export default Header
